import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { Platform } from "react-native";
import { useFragment } from "react-relay";

import { useFlags } from "@/utils/launchDarkly";
import {
  Text,
  VStack,
  HStack,
  ScrollView,
} from "@whoosh/design-system/src/components/primitive";

import { BookTodayFragment_Facilities$key } from "./__generated__/BookTodayFragment_Facilities.graphql";
import { DepartmentCard } from "./components/DepartmentCard";
import { FacilityCard } from "./components/FacilityCard";
import { useGetBookTodayData } from "./hooks/useGetBookTodayData";

type BookTodayProps = {
  bookTodayRef: BookTodayFragment_Facilities$key | null;
};

export const BookToday = ({ bookTodayRef }: BookTodayProps) => {
  const club = useFragment(bookTodayFragmentString, bookTodayRef);

  const bookTodayData = useGetBookTodayData(club ?? null);

  const { menuAndNavUpdate } = useFlags();

  return (
    <VStack width="100%" pb={8}>
      <Text
        variant="mainTitle3"
        paddingLeft={{ base: 6, md: 16, lg: 0 }}
        paddingTop={menuAndNavUpdate ? 6 : 4}
      >
        {t`Welcome! Ready to make a booking today?`}
      </Text>
      <ScrollView
        mt={{ base: 6, lg: 8 }}
        testID="book-now-scrollview"
        horizontal
        showsHorizontalScrollIndicator={Platform.OS === "web"}
        width="100%"
      >
        <HStack flex={1} gap={2} px={{ base: 6, md: 16, lg: 0 }}>
          {bookTodayData.map((data, index) =>
            data.type === "facility" ? (
              <FacilityCard key={`facility-${index}`} facilityRef={data.ref} />
            ) : (
              <DepartmentCard
                key={`department-${index}`}
                departmentRef={data.ref}
              />
            )
          )}
        </HStack>
      </ScrollView>
    </VStack>
  );
};

const bookTodayFragmentString = graphql`
  fragment BookTodayFragment_Facilities on Club {
    ...useGetBookTodayData_club
  }
`;
